import React, { type ReactNode } from 'react';
import type { FieldType } from '../../../types/EvalancheTypes';
import { Container, Input, FormLabel, ErrorMessage } from '../styles';

export const PasswordInput = ({
  field,
  formikProps,
}: {
  field: FieldType;
  formikProps: any;
}): ReactNode => (
  <Container>
    <FormLabel tag="span" type="lead" className="text-gray-500">
      {field.label}
    </FormLabel>
    <Input
      type="password"
      name={field.name}
      onChange={formikProps.handleChange}
      value={formikProps.values[field.name]}
      data-test={`password-${field.name}`}
      autoComplete="password"
      readOnly={field.readonly}
    />
    {formikProps.errors[field.name] && (
      <ErrorMessage data-test={`password-${field.name}-error`}>
        {formikProps.errors[field.name]}
      </ErrorMessage>
    )}
  </Container>
);
